import { AirlineLiteModel } from 'api-hooks/airline';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { GuestLiteModel } from 'api-hooks/guest';
import { Expose, Type } from 'class-transformer';
import { FlightCheckInStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

import { PurchaseModel } from '../common/model';

// Model
export class FlightPurchaseGuestItemModel {
  id: string;
  ticket: string;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;
}

export class FlightPurchasePreferenceModel extends CommonModel {
  name: string;
}

export class FlightPurchaseAirlineItemModel {
  id: string;
  detail: string;
  route: string;
  time: string;
  @Type(() => AirlineLiteModel)
  airline: AirlineLiteModel;

  @Type(() => Date)
  date: Date;

  @Type(() => Number)
  price: number;

  @Type(() => FlightPurchasePreferenceModel)
  preference?: FlightPurchasePreferenceModel;
}

export class FlightPurchaseAddOnsItemModel {
  id: string;
  route: string;
  description?: string;

  @Type(() => Number)
  price: number;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;
}

export class FlightPurchaseItemModel {
  id: string;

  @Expose({ name: 'booking_code' })
  bookingCode?: string | null;

  @Expose({ name: 'flight_purchase_guests' })
  @Type(() => FlightPurchaseGuestItemModel)
  flightPurchaseGuests: FlightPurchaseGuestItemModel[];

  @Expose({ name: 'flight_purchase_airlines' })
  @Type(() => FlightPurchaseAirlineItemModel)
  flightPurchaseAirlines: FlightPurchaseAirlineItemModel[];

  @Expose({ name: 'flight_purchase_add_ons' })
  @Type(() => FlightPurchaseAddOnsItemModel)
  flightPurchaseAddOns: FlightPurchaseAddOnsItemModel[];
}

export class FlightPurchaseAddOnsDetailModel {
  id: string;
  description: string;
  route: string;
  status: string;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;

  @Type(() => Number)
  price: number;
}

export class FlightPurchaseGuestDetailModel {
  id: string;
  preference: { id: string; name: string } | null;
  route: string;
  status: string;
  ticket: string | null;
  time: string;

  @Expose({ name: 'check_in_status' })
  checkInStatus: FlightCheckInStatusEnum;

  @Type(() => AirlineLiteModel)
  airline: AirlineLiteModel;

  @Type(() => Date)
  date: Date;

  detail: string;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;

  @Type(() => Number)
  price: number;
}

export class FlightPurchaseDetailModel {
  id: string;

  @Expose({ name: 'booking_code' })
  bookingCode: string | null;

  @Expose({ name: 'flight_purchase_guests' })
  @Type(() => FlightPurchaseGuestDetailModel)
  flightPurchaseGuests: FlightPurchaseGuestDetailModel[];

  @Expose({ name: 'flight_purchase_add_ons' })
  @Type(() => FlightPurchaseAddOnsDetailModel)
  flightPurchaseAddOns: FlightPurchaseAddOnsDetailModel[];
}

export class FlightPurchaseLiteModel extends CommonModel {
  code: string;
  description?: string;
  type: string;
  number: string;
  guests: { id: string; name: string }[];
  agent: string;
  status: string;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'payment_channel' })
  paymentChannel: string;

  @Type(() => Number)
  total: number;
}

export class FlightPurchaseModel extends PurchaseModel {
  @Expose({ name: 'flight_purchases' })
  @Type(() => FlightPurchaseDetailModel)
  flightPurchases: FlightPurchaseDetailModel[];
}

// Input

export type getFlightPurchasesInput = {
  params: CommonParamInput;
};

export type getFlightPurchaseInput = {
  id: string;
};

export type FlightPurchaseGuestItemInput = {
  id?: string;
  guestId: string;
  ticket: string;
};

export type FlightPurchaseAirlineItemInput = {
  id?: string;
  airlineId: string | null;
  date: Date | null;
  detail: string;
  route: string;
  preferenceId?: string;
  time: string;
  price: number;
};

export type FlightPurchaseAddOnsItemInput = {
  id?: string;
  guestId: string | null;
  route: string;
  description: string;
  price: number;
};

export type FlightPurchaseItemInput = {
  id?: string;
  bookingCode?: string | null;
  flightPurchaseGuests: FlightPurchaseGuestItemInput[];
  flightPurchaseAirlines: FlightPurchaseAirlineItemInput[];
  flightPurchaseAddOns: FlightPurchaseAddOnsItemInput[];
};

export type FlightPurchaseMutationInput = {
  //Required - Detail
  code: string;
  description: string;
  transactionAt: Date | null;
  type: string;
  agentId: string | null;
  paymentChannelId: string | null;
  tourRefId?: string | null;
  invoiceRefId?: string | null;
  flightPurchases: FlightPurchaseItemInput[];
  discount: number;
  otherCost: number;
  total: number;
  needApproval: boolean;

  // Not Required
  refId?: string | null;
  orderNumber?: string | null;
  parentRefId?: string | null;
};

export type FlightPurchaseUpdateInput = {
  flightPurchaseId: string;
  body: FlightPurchaseMutationInput;
};

export type FlightPurchaseDeleteInput = {
  flightPurchaseId: string;
};
